import React from "react";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  getDataBreachRiskStatus,
  // getDataBreachRiskExplanation,
} from "utilities/getDataBreachRiskStatus";

const DataBreachRiskIndicator = ({ columns, showTooltip = true }) => {
  const { t } = useTranslation();
  function getDataBreachRiskLabel(riskLevel, columns) {
    if (!columns || !Array.isArray(columns)) {
      return "Unknown risk level";
    }
    switch (riskLevel.status) {
      case "high":
        return t("dataBreach.risk_level_label_high");
      case "medium":
        return t("dataBreach.risk_level_label_medium");
      case "low":
        return t("dataBreach.risk_level_label_low");
      default:
        return "Unknown risk level";
    }
  }
  const riskLevel = getDataBreachRiskStatus(columns);
  const explanation = showTooltip ? getDataBreachRiskLabel(riskLevel, columns) : "";

  const getRiskColor = () => {
    switch (riskLevel.status) {
      case "high":
        return "#FF0000"; // Red
      case "medium":
        return "#FFA500"; // Orange
      case "low":
        return "#FFD700"; // Yellow
      default:
        return "#808080"; // Gray for unknown
    }
  };

  return (
    <div
      className="risk-indicator"
      style={{ display: "inline-flex", alignItems: "center", marginLeft: "8px" }}
    >
      {showTooltip ? (
        <Tooltip title={explanation} placement="top">
          <div
            className="risk-dot"
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              display: "inline-block",
              marginRight: "5px",
              backgroundColor: getRiskColor(),
            }}
          />
        </Tooltip>
      ) : (
        <div
          className="risk-dot"
          style={{
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            display: "inline-block",
            marginRight: "5px",
            backgroundColor: getRiskColor(),
          }}
        />
      )}
      <span style={{ fontSize: "14px" }}>{explanation}</span>
    </div>
  );
};

DataBreachRiskIndicator.propTypes = {
  columns: PropTypes.array.isRequired,
  showTooltip: PropTypes.bool,
};

export default DataBreachRiskIndicator;
